import React, { Component } from "react";
import { connect } from "react-redux";
import { check } from "@xams-utils/check-types";

import { api } from "libs/api/api";
import { ENDPOINTS } from "libs/api/constants";
import { setMfaOption } from "components/pages/login/form/actions";

import { MaterialText } from "components/presentation/material-text";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";
import Checkbox from "@material-ui/core/Checkbox";

import { saveRememberMe } from "./remember-me";
import { MfaResetConfirmation } from "./mfa-reset-confirmation";
import { MESSAGE_IDS } from "constants/message-ids";

const styles = ({ spacing }) => {
    return {
        textField: {
            marginLeft: spacing.unit,
            marginRight: spacing.unit,
        },
        layout: {
            "&>div:nth-child(2)": {
                marginBottom: spacing.unit * 2,
            },
        },
        button: {
            margin: spacing.unit,
        },
        error: {
            display: "flex",
            marginBottom: spacing.unit,
            "&>div:nth-child(1)": {
                marginRight: spacing.unit * 2,
            },
            "&>div:nth-child(2)": {
                marginTop: "8px",
            },
        },
        rememberMe: {
            display: "flex",
            "&>div:nth-child(1)": {
                marginRight: spacing.unit,
            },
            "&>div:nth-child(2)": {
                marginTop: "14px",
            },
        },
        reset: {
            display: "flex",
            cursor: "pointer",
            marginTop: spacing.unit,
        },
        buttons:{display:"flex", width:"100%", justifyContent:"space-between"}
    };
};

class MfaVerify extends Component {
    state = { value: "", verifying: false, error: null, rememberMe: false, confirmReset: false };

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleResetConfirmed = this.handleResetConfirmed.bind(this);
    }

    handleChange(value) {
        const { error } = this.state;

        if (check.nonEmptyString(error)) {
            this.setState({ value, error: null });
        } else {
            this.setState({ value });
        }
    }

    handleClick() {
        this.setState({ verifying: true, error: null }, () => {
            this.verifyCode();
        });
    }

    handleCheck(checked) {
        this.setState({ rememberMe: checked });
    }

    handleReset() {
        this.setState({confirmReset: true, verifying: true, error:null})
    }

    handleResetConfirmed(confirmed) {
        if (!confirmed){
            this.setState({confirmReset: false, verifying: false})
        }
        else{
            const { userId, orgId, resetMfaOption } = this.props;

            this.setState({ verifying: true }, () => {
                api.get(ENDPOINTS.MFA.RESET_PROVIDER, { userID: userId })
                    .then((response) => {
                        console.log("Reset MFA", response);

                        saveRememberMe(false, {userId, orgId});
                        resetMfaOption(0);
                    })
                    .catch((e) => {
                        console.log("Reset MFA", e);

                        this.setState({
                            error: "There was a problem resetting your authentication",
                            verifying: false,
                        });
                    });
            });
        }
    }

    verifyCode() {
        const { value, rememberMe } = this.state;
        const { userId, onVerify, orgId, mfaOption,rememberMeDays, messages } = this.props;

        api.get(ENDPOINTS.MFA.VERIFY_CODE, { userID: userId, code: value, mfaOption })
            .then((response) => {
                // if (true) {
                if (response === "true") {
                    saveRememberMe(rememberMe, { userId, orgId }, rememberMeDays);
                    onVerify();
                } else {
                    this.setState({
                        error: messages[MESSAGE_IDS.MFA.INCORRECT_VERIFICATION_CODE],
                        verifying: false,
                    });
                }
            })
            .catch((e) => {
                this.setState({
                    error: messages[MESSAGE_IDS.MFA.VERIFICATION_ERROR],
                    verifying: false,
                });
                console.log(e);
            });
    }

    displayTitle() {
        const {messages}=this.props;
        return (
            <div>
                <MaterialText variant="h6">{messages[MESSAGE_IDS.MFA.VERIFICATION_CODE]}</MaterialText>
            </div>
        );
    }

    displayInput() {
        const { value, verifying } = this.state;
        const { classes } = this.props;
        const props = {
            className: classes.textField,
            disabled: verifying,
            // margin: "normal",
            variant: "outlined",
            value,
            fullWidth: true,
            onChange: (e) => {
                this.handleChange(e.target.value);
            },
        };

        return <TextField {...props} />;
    }

    displayRememberMe() {
        const { classes, rememberMeDays, messages } = this.props;
        if (rememberMeDays<1){
            return null;
        }

        const { verifying, rememberMe } = this.state;
        const props = {
            checked: rememberMe,
            color: "primary",
            disabled: verifying,
            onChange: (e) => this.handleCheck(e.target.checked),
        };

        return (
            <div className={classes.rememberMe}>
                <Checkbox {...props} />
                <div>
                    <MaterialText>{messages[MESSAGE_IDS.MFA.REMEMBER_ME]}</MaterialText>
                </div>
            </div>
        );
    }

    displayButtons(){
        const {classes}=this.props;
        return <div class={classes.buttons}>{this.displayButton()}</div>
    }

    displayButton() {
        const { value, verifying } = this.state;
        const { classes, messages } = this.props;
        const disabled = !check.nonEmptyString(value) || verifying;
        const props = {
            variant: "contained",
            color: "primary",
            className: classes.button,
            disabled,
            onClick: this.handleClick,
        };

        return (
            <div>
                <Button {...props}>{messages[MESSAGE_IDS.MFA.VERIFY_CODE]}</Button>
            </div>
        );
    }

    displayError() {
        const { error } = this.state;

        if (check.nonEmptyString(error)) {
            const { classes } = this.props;

            return (
                <div className={classes.error}>
                    <Avatar>
                        <CloseIcon />
                    </Avatar>
                    <div>
                        <MaterialText>{error}</MaterialText>
                    </div>
                </div>
            );
        }
    }

    displayReset() {
        const { verifying, confirmReset } = this.state;
        const { enabled, classes } = this.props;

        if (!enabled) {
            return null;
        }

        const props = {
            onClick: verifying ? null : this.handleReset,
            className: classes.reset,
            variant: "contained",
            color: "secondary",
        };

        const confirmProps={
            open: confirmReset, onClose: this.handleResetConfirmed
        }

        return (
            <React.Fragment>
            <div>
                <Button {...props}>Reset Authentication</Button>
            </div>
            <MfaResetConfirmation {...confirmProps}/>
            </React.Fragment>
        );
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.layout}>
                {this.displayTitle()}
                {this.displayInput()}
                {this.displayError()}                
                {this.displayRememberMe()}
                {this.displayButtons()}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    resetMfaOption: (mfaOption = 0) => {
        dispatch(setMfaOption(mfaOption));
    },
});

MfaVerify = connect(undefined, mapDispatchToProps)(MfaVerify);

MfaVerify = withStyles(styles)(MfaVerify);

export { MfaVerify };
